import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './registration-confirmation.component'

import RegistrationContactsBlock from '../registration/common/registration-contacts-block'

let module = angular.module('registrationConfirmation', [
  uiRouter,
  RegistrationContactsBlock
])

.config(($stateProvider) => {
  'ngInject'
  $stateProvider
    .state('registrationConfirmation', {
      url: '/registration/confirm?email',
      component: 'registrationConfirmation',
      myRenaultForbidden: true,
      authenticatedForbidden: true
    })
})
.component('registrationConfirmation', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/registration-confirmation/index.js